var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 8.99984C0.666748 4.39984 4.39175 0.666504 8.99175 0.666504C13.6001 0.666504 17.3334 4.39984 17.3334 8.99984C17.3334 13.5998 13.6001 17.3332 8.99175 17.3332C4.39175 17.3332 0.666748 13.5998 0.666748 8.99984ZM9.83341 5.6665C9.83341 5.20817 9.45842 4.83317 9.00008 4.83317C8.54175 4.83317 8.16675 5.20817 8.16675 5.6665V8.99984C8.16675 9.45817 8.54175 9.83317 9.00008 9.83317C9.45842 9.83317 9.83341 9.45817 9.83341 8.99984V5.6665ZM9.00008 15.6665C5.31675 15.6665 2.33341 12.6832 2.33341 8.99984C2.33341 5.3165 5.31675 2.33317 9.00008 2.33317C12.6834 2.33317 15.6667 5.3165 15.6667 8.99984C15.6667 12.6832 12.6834 15.6665 9.00008 15.6665ZM8.16675 11.4998V13.1665H9.83341V11.4998H8.16675Z",
    fill: "#A72E12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningCircle);
export default __webpack_public_path__ + "static/media/icon-warning-circle.507a61c01e3ec7e060ee41c4cd669b88.svg";
export { ForwardRef as ReactComponent };